import { hideModal, showModal } from '@/utils/redux.helper'
import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  singleSourceProcurementModal: {
    show: false,
    costBudgetId: '',
    conditions: [],
  },
  costBudgetWorkflowModal: {
    show: false,
    offerId: '',
    costBudgetId: '',
    issues: [],
    workflowStatus: '',
    canAction: false,
  },
  vendorQuotationSelectionModal: {
    show: false,
    vendorHistory: [],
    title: 'Quotation Selection',
    updatePath: '',
    selectedIndex: -1,
    shouldSetQuotationDetails: false,
  },
  manualUploadVendorQuotationModal: {
    show: false,
    offerId: '',
    offerDetail: {},
    costBudgetId: '',
    costBudgetIndex: -1,
    vendorIndex: -1,
    isCostBudgetActive: false,
    costBudgetType: '',
    costBudgetScopeOfWork: '',
    RFQCode: '',
    projectName: '',
    managerId: '',
  },

  closeOfferModal: {
    show: false,
    offerId: '',
    type: 'offer',
  },
  PROnHoldConfirmationModal: {
    show: false,
    newQuotations: [],
    vendorName: '',
    offerId: '',
    costBudgetId: '',
    vendorIndex: -1,
    costBudgetIndex: -1,
    vendorSelectionIndex: -1,
    submissionIndex: -1,
  },
  splitCostBudgetModal: {
    show: false,
    originalCostBudgetName: '',
    originalCostBudgetRFQCode: '',
    offerId: '',
    costBudgetIndex: -1,
  },
  SOPQuestionnaireModal: {
    show: false,
    offerId: '',
  },
}

const offerModalSlice = createSlice({
  name: 'offerModal',
  initialState,
  reducers: {
    showSingleSourceProcurementModal: showModal('singleSourceProcurementModal'),
    hideSingleSourceProcurementModal: hideModal(
      'singleSourceProcurementModal',
      initialState.singleSourceProcurementModal
    ),
    showCostBudgetWorkflowModal: showModal('costBudgetWorkflowModal'),
    hideCostBudgetWorkflowModal: hideModal('costBudgetWorkflowModal', initialState.costBudgetWorkflowModal),
    showVendorQuotationSelectionModal: showModal('vendorQuotationSelectionModal'),
    hideVendorQuotationSelectionModal: hideModal(
      'vendorQuotationSelectionModal',
      initialState.vendorQuotationSelectionModal
    ),
    showManualUploadVendorQuotationModal: showModal('manualUploadVendorQuotationModal'),
    hideManualUploadVendorQuotationModal: hideModal(
      'manualUploadVendorQuotationModal',
      initialState.manualUploadVendorQuotationModal
    ),

    showCloseOfferModal: showModal('closeOfferModal'),
    hideCloseOfferModal: hideModal('closeOfferModal', initialState.closeOfferModal),
    showPROnHoldConfirmationModal: showModal('PROnHoldConfirmationModal'),
    hidePROnHoldConfirmationModal: hideModal('PROnHoldConfirmationModal', initialState.PROnHoldConfirmationModal),
    showSplitCostBudgetModal: showModal('splitCostBudgetModal', initialState.splitCostBudgetModal),
    hideSplitCostBudgetModal: hideModal('splitCostBudgetModal', initialState.splitCostBudgetModal),
    showSOPQuestionnaireModal: showModal('SOPQuestionnaireModal'),
    hideSOPQuestionnaireModal: hideModal('SOPQuestionnaireModal', initialState.SOPQuestionnaireModal),
  },
})

export const {
  showSingleSourceProcurementModal,
  hideSingleSourceProcurementModal,
  showCostBudgetWorkflowModal,
  hideCostBudgetWorkflowModal,
  showVendorQuotationSelectionModal,
  hideVendorQuotationSelectionModal,
  showManualUploadVendorQuotationModal,
  hideManualUploadVendorQuotationModal,

  showCloseOfferModal,
  hideCloseOfferModal,
  showPROnHoldConfirmationModal,
  hidePROnHoldConfirmationModal,
  showSplitCostBudgetModal,
  hideSplitCostBudgetModal,
  showSOPQuestionnaireModal,
  hideSOPQuestionnaireModal,
} = offerModalSlice.actions

export const singleSourceProcurementModalSelector = (state) => state.offerModal.singleSourceProcurementModal
export const costBudgetWorkflowModalSelector = (state) => state.offerModal.costBudgetWorkflowModal
export const vendorQuotationSelectionModalSelector = (state) => state.offerModal.vendorQuotationSelectionModal
export const manualUploadVendorQuotationModalSelector = (state) => state.offerModal.manualUploadVendorQuotationModal
export const closeOfferModalSelector = (state) => state.offerModal.closeOfferModal
export const PROnHoldConfirmationModalSelector = (state) => state.offerModal.PROnHoldConfirmationModal
export const splitCostBudgetModalSelector = (state) => state.offerModal.splitCostBudgetModal
export const SOPQuestionnaireModalSelector = (state) => state.offerModal.SOPQuestionnaireModal

export default offerModalSlice.reducer
